module.exports = __webpack_public_path__ + "static/media/2728_color.d7d1ddfc.svg";